export const API_BASE_URL = 'https://api.themoviedb.org/3/'
export const API_IMAGE_URL = 'https://image.tmdb.org/t/p/original/'
